import { CheckMark } from '@/components/CheckMark';

interface QasaInfoBoxProps {
    heading: string;
    content: string;
}

export const QasaInfoBox = ({ heading, content }: QasaInfoBoxProps) => {
    return (
        <div className="flex rounded-[16] p-[24] s-bg gap-8">
            <CheckMark />
            <div className="pt-6">
                <p className="t4">{heading}</p>
                <p>{content}</p>
            </div>
        </div>
    );
};
